import { Component } from '@angular/core';
import { Router } from '@angular/router';

interface AgricolaReportesCard {
  title: string;
  description: string;
  icon: string;
  iconBg: string;
  route: string;
  isNew?: boolean;
}

@Component({
  selector: 'app-agricola-reportes',
  templateUrl: './agricola-reportes.component.html',
  styleUrls: ['./agricola-reportes.component.css'],
  standalone: false
})
export class AgricolaReportesComponent {

  cards: AgricolaReportesCard[] = [
    {
      title: 'Reporte de ventas',
      description: 'Consulta las ventas emitidas',
      icon: 'fas fa-chart-bar',
      iconBg: 'linear-gradient(135deg, #0d9488 0%, #0891b2 100%)',
      route: '/agricola/reportes/ventas',
      isNew: true
    },
    {
      title: 'Mis reportes',
      description: 'Descarga tus reportes generados',
      icon: 'fas fa-file-download',
      iconBg: 'linear-gradient(135deg, #7c3aed 0%, #4f46e5 100%)',
      route: '/agricola/reportes/cola'
    }
  ];

  constructor(private readonly router: Router) {}

  onCardClick(card: AgricolaReportesCard): void {
    this.router.navigate([card.route]);
  }

  goBack(): void {
    this.router.navigate(['/agricola']);
  }
}
